/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTachometerAlt, 
  faUsers, 
  faBriefcase, 
  faUserTie, 
  faUserGraduate,
  faCreditCard, 
  faChartBar, 
  faCog, 
  faShieldAlt,
  faFileUpload,
  faBuilding,
  faIdCard,
  faFileContract,
  faEnvelopeOpenText,
  faQuoteLeft,
  faBook,
  faCheckCircle,
  faQuestionCircle,
  faFileAlt,
  faVideo,
  faShareAlt,
  faImages,
  faCalendarAlt
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import '../styles/AdminSidebar.css'; // Replaced by unified CSS

const AdminSidebar = ({ activeView, setActiveView }) => {
  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faTachometerAlt,
      description: 'System Overview'
    },
    {
      id: 'jobseeker-matrix',
      label: 'Job Seeker Matrix',
      icon: faUsers,
      description: 'Control Job Seeker Features'
    },
    {
      id: 'recruiter-matrix',
      label: 'Recruiter Matrix',
      icon: faUserTie,
      description: 'Control Recruiter Features'
    },
    {
      id: 'intern-matrix',
      label: 'Intern Matrix',
      icon: faUserGraduate,
      description: 'Control Intern Features'
    },
    {
      id: 'employer-matrix',
      label: 'Employer Matrix',
      icon: faBuilding,
      description: 'Control Employer Features'
    },
    {
      id: 'plans',
      label: 'Subscription Plans',
      icon: faCreditCard,
      description: 'Manage Pricing & Plans'
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: faChartBar,
      description: 'Reports & Insights'
    },
    {
      id: 'users',
      label: 'User Management',
      icon: faUsers,
      description: 'Manage User Accounts'
    },
    {
      id: 'deactivate-jobs',
      label: 'Deactivate Jobs',
      icon: faBriefcase,
      description: 'Hide outdated job posts'
    },
    {
      id: 'share-jobs',
      label: 'Share Jobs',
      icon: faShareAlt,
      description: 'Share jobs on social media'
    },
    {
      id: 'approvals',
      label: 'Account Approvals',
      icon: faCheckCircle,
      description: 'Approve Recruiters & Employers'
    },
    {
      id: 'email-services',
      label: 'Email Services',
      icon: faEnvelopeOpenText,
      description: 'Monitor Email Sending & Limits'
    },
    {
      id: 'profile-browser',
      label: 'Profile Browser',
      icon: faIdCard,
      description: 'Browse All User Profiles'
    },
    {
      id: 'bulk-import',
      label: 'Bulk Import',
      icon: faFileUpload,
      description: 'Import Users from CSV/Excel'
    },
    {
      id: 'testimonials',
      label: 'Testimonials',
      icon: faQuoteLeft,
      description: 'Manage homepage stories'
    },
    {
      id: 'blogs',
      label: 'Blogs',
      icon: faBook,
      description: 'Manage blog posts'
    },
    {
      id: 'events',
      label: 'Events',
      icon: faCalendarAlt,
      description: 'Manage public events page'
    },
    {
      id: 'expo-gallery',
      label: 'Expo Gallery',
      icon: faImages,
      description: 'Upload expo & career fair photos'
    },
    {
      id: 'team-members',
      label: 'Team Members',
      icon: faUsers,
      description: 'Manage About Us team photos'
    },
    {
      id: 'volunteer-cards',
      label: 'Volunteer Cards',
      icon: faIdCard,
      description: 'Create & download volunteer cards'
    },
    {
      id: 'employer-browser',
      label: 'Employer Browser',
      icon: faBuilding,
      description: 'Manage Employer Lists & Coins'
    },
    {
      id: 'settings',
      label: 'System Settings',
      icon: faCog,
      description: 'Global Configuration'
    },
    {
      id: 'security',
      label: 'Security',
      icon: faShieldAlt,
      description: 'Security & Privacy'
    },
    {
      id: 'legal',
      label: 'Legal Policies',
      icon: faFileContract,
      description: 'Edit Terms & Privacy'
    },
    {
      id: 'about-platform',
      label: 'About Platform',
      icon: faFileAlt,
      description: 'Edit About Platform page'
    },
    {
      id: 'faqs',
      label: "FAQ's",
      icon: faQuestionCircle,
      description: 'Manage Help Center FAQs'
    },
    {
      id: 'help-videos',
      label: 'Help Videos',
      icon: faVideo,
      description: 'Manage Help Center video tutorials'
    },
    {
      id: 'marketing',
      label: 'Marketing',
      icon: faWhatsapp,
      description: 'Send WhatsApp Marketing Messages'
    }
  ];

  return (
    <div className="admin-sidebar">
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeView === item.id ? 'active' : ''}`}
            onClick={() => setActiveView(item.id)}
          >
            <div className="nav-icon">
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <div className="nav-content">
              <span className="nav-label">{item.label}</span>
              <span className="nav-description">{item.description}</span>
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default AdminSidebar;
